import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";

const ProductActions = ({
    isOutOfStock,
    addingToCart,
    onAddToCart,
    onQuickBuy
}) => {
    const { language } = useLanguage();

    // Translations for product actions
    const translations = {
        en: {
            addToCart: "Add to Cart",
            quickBuy: "Quick Buy",
            adding: "Adding...",
            processing: "Processing..."
        },
        ar: {
            addToCart: "أضف إلى السلة",
            quickBuy: "شراء سريع",
            adding: "جارٍ الإضافة...",
            processing: "جارٍ المعالجة..."
        }
    };

    const t = translations[language] || translations.en;
    return (
        <div className="product-actions">
            <button
                className="add-to-cart"
                disabled={isOutOfStock || addingToCart}
                onClick={onAddToCart}
            >
                {addingToCart ? t.adding : t.addToCart}
            </button>

            <button
                className="quick-buy"
                disabled={isOutOfStock || addingToCart}
                onClick={onQuickBuy}
            >
                {addingToCart ? t.processing : t.quickBuy}
            </button>
        </div>
    );
};

export default ProductActions;